// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4292 ? "a998cefd" : chunkId) + "." + {"4292":"7f37df4a5135320a","5375":"65cc70cbf747bd5b","7843":"45971987f3b531ff"}[chunkId] + ".js";
};